<template>
    <div>
        <div class="modosweb-filtro-inline-collapse" style="display: flex; justify-content: flex-end;">
            <div class="modosweb-filtro-header">
                <button type="button" v-if="!esconderBotao" style="float: inline-end;"
                    class="btn-toggle mb-3 v-btn v-btn--has-bg theme--light v-size--default primary button-orientation "
                    @click="toggleOpen">
                    {{ open ? 'Ocultar filtros' : 'Mostrar filtros' }}
                </button>
            </div>
        </div>

        <div class="modosweb-filtro-inline-collapse">

            <transition name="modosweb-collapse">
                <div v-show="open" class="modosweb-filtro-body">

                    <div class="modosweb-filtro-inline">
                        <div v-for="(input, index) in form" :key="input.name" class="mw-field">
                            <SGPFormSelectComponent
                                v-if="!input.type || input.type === 'select' || input.type === 'unico'"
                                :name="input.name" v-model="input.value" :placeholder="input.label"
                                :listaDeOptions="input.options" optionValue="value" optionLabel="text"
                                @change="emitChange(index)" />

                            <SGPFormAutocompleteComponent v-else-if="input.type === 'auto_complete'"
                                v-model="input.value" :listaDeOptions="input.options" optionValue="value"
                                optionLabel="text" :placeholder="input.label" @change="emitChange(index)" />

                            <SGPFormInputComponent v-else-if="input.type === 'text'" v-model="input.value"
                                :placeholder="input.label" @input="emitChange(index)" />

                            <SGPFormDataComponent v-else-if="input.type === 'date'" v-model="input.value"
                                :placeholder="input.label" :time="input.time" @change="emitChange(index)" />

                            <SGPFormMesComponent v-else-if="input.type === 'month'" v-model="input.value"
                                :name="input.name" :placeholder="input.label" @change="emitChange(index)" />

                            <SGPFormDataRangeComponent v-else-if="input.type === 'range'" v-model="input.value"
                                :placeholder="input.label" @change="emitChange(index)" />

                            <SGPFormSelectComponent v-else v-model="input.value" :placeholder="input.label"
                                :listaDeOptions="input.options" optionValue="value" optionLabel="text" selecaoMultipla
                                @change="emitChange(index)" />
                        </div>
                    </div>

                    <div class="modosweb-filtro-actions">
                        <SGPFormBotaoComponent rounded color="primary" @click="aplicarFiltro">
                            Filtrar
                        </SGPFormBotaoComponent>

                        <SGPFormBotaoComponent rounded color="grey-5" @click="limparCampos">
                            Limpar
                        </SGPFormBotaoComponent>
                    </div>

                </div>
            </transition>
        </div>
    </div>
</template>

<script>
export default {
    name: "ModosWebFiltroInlineCollapseComponent",

    props: {
        campos: {
            type: Array,
            required: true
        },
        esconderBotao: {
            type: Boolean,
            default: false
        },
        inicialOpen: {
            type: Boolean,
            default: false
        }
    },

    data() {
        return {
            open: this.inicialOpen,
            form: []
        };
    },

    methods: {
        toggleOpen() {
            this.open = !this.open;
            this.$emit('open-change', this.open);
        },

        aplicarFiltro() {
            this.$emit("modosWebFormFilterDadosClick", this.normalizarSaida());
        },

        limparCampos() {
            this.form.forEach(f => {
                if (f.type === "multiplo") f.value = [];
                else if (f.type === "date" || f.type === "month") f.value = null;
                else f.value = "";
            });

            this.$emit("modosWebFormFilterLimpar");
        },

        emitChange(index) {
            const item = this.form[index];

            if (item.options && item.value) {
                const opt = item.options.find(o => o.value === item.value);
                item.valueLabel = opt ? opt.text : "";
            }

            this.$emit("modosWebFormFilterDadosChange", this.normalizarSaida());
        },

        normalizarSaida() {
            const obj = {};

            this.form.forEach(f => {
                obj[f.name] = f.value ?? "";
            });

            return obj;
        }
    },

    watch: {
        campos: {
            immediate: true,
            handler(campos) {
                this.form = campos.map(c => {
                    const antigo = this.form.find(f => f.name === c.name);

                    return {
                        ...c,
                        value: antigo ? antigo.value : c.value
                    };
                });
            }
        }
    }
};
</script>

<style scoped>
.modosweb-filtro-inline-collapse {
    width: 100%;
}

.btn-toggle {
    background: transparent;
    border: 1px solid #ccc;
    padding: 6px 12px;
    border-radius: 5px;
    cursor: pointer;
    white-space: nowrap;
}

.modosweb-filtro-body {
    margin-top: 10px;
}

.modosweb-filtro-inline {
    display: flex;
    flex-wrap: wrap;
    gap: 14px;
    width: 100%;
}

.mw-field {
    flex: 1 1 250px;
}

.modosweb-filtro-actions {
    margin-top: 16px;
    display: flex;
    gap: 12px;
}

:deep(.v-text-field__details) {
    display: none !important;
    min-height: 0 !important;
}

:deep(.v-messages) {
    min-height: 0 !important;
}
</style>
